var path = '/app/pages/bookmarks/bookmarks.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/bookmarks/bookmarks.html
// module id = 977
// module chunks = 0